"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = exports.getNewCursorPosition = exports.MaskedPhoneNumberInputSchema = void 0;
exports.default = MaskedPhoneNumberInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const z = __importStar(require("zod"));
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
exports.MaskedPhoneNumberInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return z.object({ [fieldName]: validation });
        },
    };
})({
    // validations:
    default: z.coerce.string().regex(/^\(\d{3}\) \d{3}-\d{4}$/, 'Valid Phone Number Required'),
});
const getNewCursorPosition = (oldValue, newValue, oldCursorPos) => {
    // If we're at the end, stay at the end
    if (oldCursorPos >= oldValue.length) {
        return newValue.length;
    }
    // Count digits before cursor in old value
    let digitsBefore = 0;
    for (let i = 0; i < oldCursorPos && i < oldValue.length; i++) {
        if (/\d/.test(oldValue[i])) {
            digitsBefore++;
        }
    }
    // Find position in new value where we have the same number of digits before
    let newPos = 0;
    let digitsFound = 0;
    for (let i = 0; i < newValue.length; i++) {
        if (/\d/.test(newValue[i])) {
            if (digitsFound === digitsBefore) {
                newPos = i;
                break;
            }
            digitsFound++;
        }
        newPos = i + 1;
    }
    return Math.min(newPos, newValue.length);
};
exports.getNewCursorPosition = getNewCursorPosition;
const formatPhoneNumber = (val) => {
    // Remove all non-digit characters from the input
    const digits = val.replace(/\D/g, '');
    if (digits.length === 0) {
        return '';
    }
    else if (digits.length <= 3) {
        return `(${digits}`;
    }
    else if (digits.length <= 6) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    }
    else {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }
};
exports.formatPhoneNumber = formatPhoneNumber;
function MaskedPhoneNumberInput(_a) {
    var _b;
    var { label, name } = _a, props = __rest(_a, ["label", "name"]);
    const [initialFormatting, setInitialFormatting] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)();
    const cursorPositionRef = (0, react_1.useRef)();
    const { control, setValue } = (0, react_hook_form_1.useFormContext)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    field.value = (0, exports.formatPhoneNumber)(field.value);
    (0, react_1.useEffect)(() => {
        if (!initialFormatting) {
            setValue(name, (0, exports.formatPhoneNumber)(field.value));
            setInitialFormatting(true);
        }
    }, [initialFormatting, setValue, name, field.value]);
    (0, react_1.useEffect)(() => {
        if (cursorPositionRef.current && inputRef.current) {
            const { oldValue, newValue, cursorPosition } = cursorPositionRef.current;
            const newCursorPosition = (0, exports.getNewCursorPosition)(oldValue, newValue, cursorPosition);
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            }, 0);
            cursorPositionRef.current = undefined;
        }
    });
    const handleOnChange = (e) => {
        const inputValue = e.target.value;
        const cursorPosition = e.target.selectionStart;
        const oldValue = field.value;
        const formatted = (0, exports.formatPhoneNumber)(inputValue);
        cursorPositionRef.current = {
            oldValue,
            newValue: formatted,
            cursorPosition: cursorPosition !== null && cursorPosition !== void 0 ? cursorPosition : 0,
        };
        field.onChange(formatted);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({ inputRef: inputRef, label: label, error: Boolean(error), helperText: ((_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : props.helperText), placeholder: "(XXX) XXX-XXXX", sx: {
            '& .MuiInputLabel-root': {
                color: error ? 'error.dark' : undefined,
            },
        } }, field, { onChange: handleOnChange, required: true }, props)));
}
//# sourceMappingURL=MaskedPhoneNumberInput.js.map